import { Card } from "@/components/ui/card";
import { statsData } from "@/lib/data/stats";
import { StatsCard } from "./StatsCard";

export function StatsDashboard() {
  return (
    <section className="w-full">
      <div className="container mx-auto">
        <Card className="border-none bg-gray-100/70 p-3 shadow-sm dark:bg-gray-800 sm:p-4 md:p-6">
          {/* Grid layout for mobile/tablet, single row flex for large desktop */}
          <div className="grid grid-cols-5 gap-1.5 sm:gap-2 md:gap-3 xl:flex xl:items-center xl:justify-between xl:space-x-4">
            {statsData.map((stat) => (
              <StatsCard key={stat.id} stat={stat} />
            ))}
          </div>
        </Card>
      </div>
    </section>
  );
}
